/**
 * Carries the context of a request into the SCIA contact form.
 * A "Richiedi disponibilità" or "Candidati" button links to the contact page with ?subject=<name>&reason=<key>:
 * the subject is shown above the form and sent with it, and the matching reason is preselected.
 * When both are known the reason field is hidden: its value is still sent with the form.
 * Without those parameters, or without JavaScript, the form works exactly as before.
 */

const SUBJECT_MAX_LENGTH = 120;
const REASON_KEYWORDS = Object.freeze({
  experience: 'esperienz',
  coach: 'coach',
  candidatura: 'candidatura',
  ambassador: 'ambassador',
  partner: 'collabora',
  hotel: 'hotel',
});

/**
 * @param {URLSearchParams} params
 * @returns {string} The subject as plain text, trimmed and capped. Empty when missing.
 */
function readSubject(params) {
  return (params.get('subject') ?? '').trim().slice(0, SUBJECT_MAX_LENGTH);
}

/**
 * @param {HTMLFormElement} form
 * @param {string} subject
 */
function showSubject(form, subject) {
  const box = form.querySelector('[data-contact-subject]');
  const name = form.querySelector('[data-contact-subject-name]');
  const input = form.querySelector('[data-contact-subject-input]');
  if (!(box instanceof HTMLElement) || !(name instanceof HTMLElement) || !(input instanceof HTMLInputElement)) return;

  name.textContent = subject;
  input.value = subject;
  input.disabled = false;
  box.hidden = false;
}

/**
 * @param {HTMLFormElement} form
 * @param {string} reasonKey
 */
function selectReason(form, reasonKey) {
  const keyword = REASON_KEYWORDS[reasonKey];
  const select = form.querySelector('[data-contact-reason]');
  if (!keyword || !(select instanceof HTMLSelectElement) || select.value !== '') return;

  const match = Array.from(select.options).find((option) => option.value.toLowerCase().includes(keyword));
  if (match) select.value = match.value;
}

/**
 * Hides the reason field once the request names its subject and a reason is selected.
 * The select keeps its value and stays in the form, so the reason is still submitted.
 * @param {HTMLFormElement} form
 */
function hideAnsweredReason(form) {
  const field = form.querySelector('[data-contact-reason-field]');
  const select = form.querySelector('[data-contact-reason]');
  if (!(field instanceof HTMLElement) || !(select instanceof HTMLSelectElement) || select.value === '') return;

  field.hidden = true;
}

function init() {
  const params = new URLSearchParams(window.location.search);
  const subject = readSubject(params);
  const reasonKey = (params.get('reason') ?? '').toLowerCase();
  if (!subject && !reasonKey) return;

  for (const form of document.querySelectorAll('form[data-contact-context]')) {
    if (!(form instanceof HTMLFormElement)) continue;
    if (subject) showSubject(form, subject);
    if (reasonKey) selectReason(form, reasonKey);
    if (subject && reasonKey) hideAnsweredReason(form);
  }
}

init();
